function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Kostenbesparing-totaal",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Energiebesparing-tot-heden",
  transform: "translate(1.000000, 6.000000)",
  stroke: "#485156",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "wedding-money-piggy",
  transform: "translate(0.000000, 0.800000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.1875,10.453125 C11.5240485,10.453125 11.796875,10.7259515 11.796875,11.0625",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.578125,11.0625 C10.578125,10.7259515 10.8509515,10.453125 11.1875,10.453125",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.1875,11.671875 C10.8509515,11.671875 10.578125,11.3990485 10.578125,11.0625",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.796875,11.0625 C11.796875,11.3990485 11.5240485,11.671875 11.1875,11.671875",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 8.767875,
  y1: 26.8315,
  x2: 7.53125,
  y2: 31.78125,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 25.79625,
  y1: 26.838,
  x2: 27.03125,
  y2: 31.78125,
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.655875,2.9635 L10.46275,0.303375 C10.120778,0.0172794045 9.64974502,-0.0589330522 9.23500316,0.104727338 C8.8202613,0.268387728 8.52820162,0.64572254 8.47375,1.08825 L7.903375,5.656125 C5.69386443,7.32518411 4.05875392,9.64069141 3.225,12.28125 L0.21875,12.28125 L0.21875,22.03125 L4.265,22.03125 C6.96796199,26.6372874 11.9414084,29.4313584 17.28125,29.34375 C25.359125,29.34375 31.9062582,23.341 31.9062582,15.9375 C31.9067243,15.5304972 31.8866571,15.1237298 31.846125,14.71875",
  id: "Path"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M19,9.46666625 L20.0667241,9.46666625 C23.0124013,9.46666625 25.4003444,7.07885172 25.4003444,4.13333322 C25.4003444,2.95512581 26.3555217,2 27.5337926,2 C29.1328745,2 30.4291865,3.29624218 30.4291865,4.89523794 L30.4291865,6.26666643 C30.4291865,6.85577013 30.9067751,7.33333304 31.4959106,7.33333304 L31.8006889,7.33333304 C32.7046892,7.33358006 33.5664145,7.71613778 34.1729052,8.38646404 C34.7793959,9.05679031 35.0740679,9.95234532 34.9840983,10.851809 L34.6534138,14.1584755 C34.4350108,16.3393075 32.5997097,18 30.407852,18 C28.9466135,18 27.4765662,18 25.9977099,18 C25.6013082,18.0002552 25.2068337,17.9448573 24.8258373,17.8354277 L22.2352217,17.0979039 C21.8542254,16.9884743 21.4597508,16.9330764 21.0633491,16.9333325 L19,16.9333325 L19,9.46666625 Z",
  id: "Path-Copy",
  stroke: "#425CD4",
  strokeWidth: 2
}));
function SvgKostenbesparingtotaal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "43px",
    viewBox: "0 0 40 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Kostenbesparing totaal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKostenbesparingtotaal);
export default __webpack_public_path__ + "static/media/Kostenbesparing totaal.97d36c42818f8365d70eaa72f97174b3.svg";
export { ForwardRef as ReactComponent };